
/**
 * webchat scroll down the webchat body container
 */
export const scrolldown = () => {
    const webchatBody = document.getElementById('webchat-container__body') as HTMLElement;

    if (webchatBody) {
        webchatBody.scrollTop = webchatBody.scrollHeight;
    }
};
